<template>
  <svg>
    <use :xlink:href="path" />
  </svg>
</template>

<script>
import {
  getPath,
  getBrandPath,
  getProductCollectionsPath,
  getCrafterpayPath,
  getPrintPath
} from "common/utils/ui/use_svg";

export default {
  name: "UseSvg",
  props: {
    icon: {
      required: true,
      type: String
    },
    type: {
      validator(value) {
        return ["jiffy", "product_collections", "crafterpay", "brand_page", "print"].includes(
          value
        );
      },
      default: "jiffy"
    }
  },
  computed: {
    path() {
      let svgPath = getPath();

      if (this.type === "brand_page") {
        svgPath = getBrandPath();
      } else if (this.type === "product_collections") {
        svgPath = getProductCollectionsPath();
      } else if (this.type === "crafterpay") {
        svgPath = getCrafterpayPath();
      } else if (this.type === "print") {
        svgPath = getPrintPath();
      }

      return `${svgPath}#${this.icon}`;
    }
  }
};
</script>
